export default "8a267f54618cad92.svg"